import { render, staticRenderFns } from "./chakanzixun.vue?vue&type=template&id=5df384dc&scoped=true&"
import script from "./chakanzixun.vue?vue&type=script&lang=js&"
export * from "./chakanzixun.vue?vue&type=script&lang=js&"
import style0 from "./chakanzixun.vue?vue&type=style&index=0&id=5df384dc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df384dc",
  null
  
)

export default component.exports